import { ActionReducerMap, createFeatureSelector } from '@ngrx/store';

import { IAppRootState } from '../../core/store';
import { connectorOriginalReducer } from './connector.reducer';
import {
	ConnectorOriginalSliceState,
	ConnectorSliceKey,
} from './connector.state';

export const ConnectorFeatureKey = 'Connector';

export interface ConnectorFeatureState {
	[ConnectorSliceKey]: ConnectorOriginalSliceState;
}

export interface ConnectorRootState extends IAppRootState {
	[ConnectorFeatureKey]: ConnectorFeatureState;
}

export const featureSelector =
	createFeatureSelector<ConnectorFeatureState>(ConnectorFeatureKey);

export const connectorReducers: ActionReducerMap<ConnectorFeatureState> = {
	[ConnectorSliceKey]: connectorOriginalReducer,
};
